import React, { useEffect, useState } from "react";
import { Button, CloseButton, Offcanvas } from "react-bootstrap";
import CallResponse from "./CallResponse";
import SaveFeedback from "./SaveFeedBack";
import Comments from "./Comments";
import Tick from "assets/svgs/tick";
import BlueTick from "assets/svgs/blue_tick";
import { formDisposition } from "config";

function ClinicSlotDisposition({ week, id, bookingId }) {
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    callResponse: null,
    comments: null,
    clinicVisit: null,
  });

  const renderedComponents = [
    { name: "callResponse", value: formData.callResponse },
    { name: "clinicVisit", value: formData.clinicVisit },
  ];
  const formRow = "d-flex gap-3";
  const buttonStyle =
    "border rounded-2 mb-0 p-2 cursor-pointer option-hover flex-1 text-center";
  const selected =
    "border rounded-2 mb-0 p-2 cursor-pointer bg-primary text-white flex-1 text-center";

  const handleShow = (breakpoint) => {
    setFullscreen(breakpoint);
    setShow(true);
  };

  useEffect(() => {}, [week]);

  return (
    <>
      <Button className="flex-1" onClick={() => handleShow("lg-down")}>
          <Tick />
      </Button>
      <Offcanvas
        show={show}
        placement={"end"}
        style={{ width: "40%" }}
        onHide={() => setShow(false)}
      >
        <Offcanvas.Header CloseButton>
          <Offcanvas.Title>Add Feedback</Offcanvas.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setShow(false)}
          />
        </Offcanvas.Header>
        <Offcanvas.Body
          style={{ maxHeight: "85vh", overflowY: "scroll" }}
          className="scrollable-container"
        >
          <div>
            <CallResponse
              formData={formData}
              buttonStyle={buttonStyle}
              selected={selected}
              setFormData={setFormData}
              formRow={formRow}
            />
            {formData.callResponse === "answered" && (
              <div className="mt-3">
                <label className="d-block mb-2 fs-1">
                  Is customer coming to the clinic?
                </label>
                <div className={formRow}>
                  {["Yes", "No", "Can't say"].map((option) => (
                    <div
                      key={option}
                      className={
                        formData.clinicVisit === option ? selected : buttonStyle
                      }
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          clinicVisit: option,
                        }))
                      }
                    >
                      {option}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {formData.callResponse === "answered" && (
              <div className="mt-3 d-flex flex-column gap-2">
                <Comments setFormData={setFormData} />
                <SaveFeedback
                  setShow={setShow}
                  bookingId={bookingId}
                  week={week}
                  formData={formData}
                  selected={selected}
                  buttonStyle={buttonStyle}
                  formRow={formRow}
                  renderedComponents={renderedComponents}
                  id={id}
                />
              </div>
            )}
            {formDisposition.includes(formData?.callResponse) && (
              <SaveFeedback
                setShow={setShow}
                bookingId={bookingId}
                week={week}
                formData={formData}
                selected={selected}
                buttonStyle={buttonStyle}
                formRow={formRow}
                renderedComponents={renderedComponents}
                id={id}
              />
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default ClinicSlotDisposition;
